module.exports = __webpack_public_path__ + "front/img/c1.17f614f2.png";